import styles from './AnswersForm.module.scss';
import TrashIcon from '../../../../../../../../assets/icons/close.svg?react';
import { TextInput, TextInputValue } from '../../../../../../../../components/text-input/TextInput';
import { ValidationErrors } from '../../useFeddbackFormEdit';
import IconPlus from '../../../../../../../../assets/icons/plus_circle_filled.svg?react';
import { MultiLineTextInput } from '@src/components/text-input/MultiLineTextInput';

type Props = {
  description: string;
  answers: string[];
  showError: boolean;
  onRemove: (index: number) => void;
  onChange: (index: number, value: TextInputValue) => void;
  onAdd: () => void;
  onUpdateHeading?: (value: TextInputValue) => void;
  noDescription?: boolean;
};

function AnswersForm(props: Props) {
  const { description, answers, showError, noDescription=false, onRemove, onChange, onAdd, onUpdateHeading } = props;
  const handleRemoveOption = (index: number) => () => {
    onRemove(index);
  };

  const handleChangeOption = (index: number) => (value: TextInputValue) => {
    onChange(index, value);
  };

  const handleAddOption = () => onAdd();

  const answersLength = answers.length;

  return (
    <>
      <div className={styles.row}>
        {!noDescription && <TextInput
          label={''}
          id={''}
          value={description}
          onChange={(val) => onUpdateHeading && onUpdateHeading(val)}
        />}
      </div>
      {(answers ?? []).map((optionStr, index) => {
        const error = showError && !optionStr;
        return (
          <div key={index} className={`${styles.row} ${styles.option}`}>
            <button className={styles.removeButton} onClick={handleRemoveOption(index)}>
              <TrashIcon stroke='#999999' className={styles.iconRemove}/>
            </button>
            <div className={styles.questionBox}>
              <MultiLineTextInput
                allowSpecialCharacters={false}
                label={''}
                id={`${index}`}
                value={optionStr}
                placeholder={'Enter answer choice'}
                onChange={handleChangeOption(index)}
                hasError={error}
                subTitle={error ? ValidationErrors.empty : ''}
              />
            </div>
          </div>
        );
      })}
      <div className={styles.row}>
        <button className={styles.button} onClick={handleAddOption}>
          <IconPlus className={styles.iconPlus}/>
        </button>
        {showError && answersLength < 1 && <div className={styles.error}>Please, add at least a option</div>}
      </div>
    </>
  );
}

export default AnswersForm;